import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { WelcomeScreen } from './components/WelcomeScreen';
import { PromptForm } from './components/PromptForm';
import { ResultScreen } from './components/ResultScreen';

export default function App() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      {/* Logo and Link Section */}
      <header className="w-full py-8 flex flex-col items-center justify-center">
        <img 
          src="https://i.imgur.com/c3a8uhc.png" 
          alt="T-Squared Technology Logo" 
          className="w-32 h-32 mb-4 hover:scale-105 transition-transform"
        />
        <a 
          href="https://tsquared.technology" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-blue-600 hover:text-blue-800 font-medium transition-colors hover:underline"
        >
          Go to TSquared.Technology Site
        </a>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <Routes>
            <Route path="/" element={<WelcomeScreen />} />
            <Route path="/create" element={<PromptForm />} />
            <Route path="/result" element={<ResultScreen />} />
          </Routes>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-6 mt-auto">
        <div className="max-w-7xl mx-auto px-4 text-center text-gray-600">
          <p>Powered by T-Squared Technology</p>
        </div>
      </footer>
    </div>
  );
}